








































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { Agence, UpdateAgenceModel } from "@/api/models/structures/agence";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "update-agence",
})
export default class UpdateAgence extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateAgenceSidebarActive!: boolean;
  @Prop({ required: true }) agenceId!: string;

  loading = false;
  required = required;
  loadingAgence = false;

  agence: UpdateAgenceModel = {};

  async created() {
    await this.$http.myressif.structures
      .getAgenceById(this.$route.params.id, this.agenceId)
      .then((res: Agence) => {
        this.agence = res;
        this.loadingAgence = true;
      });
      console.log("c", this.isUpdateAgenceSidebarActive)
  }

  resetForm() {
    this.agence = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.structures
      .updateAgenceStructure(
        this.$route.params.id,
        this.agenceId,
        this.agence
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification d'une agence",
            text: "Agence modifiée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-agence");
        this.$emit("update:is-update-agence-sidebar-active", false);
        this.loading = false;
      });
  }
}
